import { InputConfig } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountOrganizationEmployeeCooperationStatusChoices,
  AuthAccountOrganizationJobPositionLocationTypeChoices,
} from "@graphql/generated";

export interface IFormData {
  title?: string;
  locationType?: { label: string; value: AuthAccountOrganizationJobPositionLocationTypeChoices };
  status?: { label: string; value: AuthAccountOrganizationEmployeeCooperationStatusChoices };
}

export const inputConfigs: InputConfig[] = [
  {
    name: "title",
    previewSize: {
      sm: 12,
      lg: 4,
    },
    inputProps: {
      type: "text",
      label: "Employee name :",
      placeholder: "Enter name",
    },
  },
  {
    name: "locationType",
    previewSize: {
      sm: 12,
      lg: 4,
    },
    inputProps: {
      type: "searcher",
      label: "Career field :",
      placeholder: "Select career",
      labelKey: "label",
      valueKey: "value",
      items: [
        { label: "All", value: null },
        { label: "Remote", value: AuthAccountOrganizationJobPositionLocationTypeChoices.REMOTE },
        { label: "Hybrid", value: AuthAccountOrganizationJobPositionLocationTypeChoices.HYBRID },
        { label: "On-site", value: AuthAccountOrganizationJobPositionLocationTypeChoices.PRECISE_LOCATION },
        { label: "On the road", value: AuthAccountOrganizationJobPositionLocationTypeChoices.ON_THE_ROAD },
        { label: "Global", value: AuthAccountOrganizationJobPositionLocationTypeChoices.GLOBAL },
        { label: "In person", value: AuthAccountOrganizationJobPositionLocationTypeChoices.LIMITED_AREA },
      ],
    },
  },
  {
    name: "status",
    previewSize: {
      sm: 12,
      lg: 4,
    },
    inputProps: {
      type: "searcher",
      label: "Status",
      placeholder: "all Status",
      labelKey: "label",
      valueKey: "value",
      items: [
        {
          label: "Active",
          value: AuthAccountOrganizationEmployeeCooperationStatusChoices.ACTIVE,
        },
        {
          label: "Suspended",
          value: AuthAccountOrganizationEmployeeCooperationStatusChoices.SUSPENDED,
        },
        {
          label: "Ended",
          value: AuthAccountOrganizationEmployeeCooperationStatusChoices.FINISHED,
        },
        {
          label: "Awaiting start",
          value: AuthAccountOrganizationEmployeeCooperationStatusChoices.AWAITING,
        },
        {
          label: "Fired",
          value: AuthAccountOrganizationEmployeeCooperationStatusChoices.FIRED,
        },
        {
          label: "All",
          value: null,
        },
      ],
    },
  },
];
